import { post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/cloudECounter/applicantInsuredNameChange';

export function postInfo() {
    return post(`${url}/info`);
}

export function postSubmit(data) {
    return post(`${url}/submit`, data, {
        ...options,
        repeatRequestCancel: true,
    });
}

export function postAgree(isChecked) {
    return post(`api/endorse/agree`, { isChecked: isChecked });
}

